export default "__VITE_ASSET__81f324e1__"